var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartV2 = function SvgCartV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.694 0c.505 0 .914.396.914.885s-.41.885-.914.885h-2.85l-1.44 11.106-.006.03a2.642 2.642 0 0 1-.97 1.552 2.8 2.8 0 0 1-1.762.586H3.883a2.8 2.8 0 0 1-1.762-.586 2.642 2.642 0 0 1-.97-1.551l-.006-.029L0 4.425h15.658L16.23 0h4.463zM14.6 12.588l.828-6.393H2.083l.866 6.39a.882.882 0 0 0 .318.494c.167.13.376.2.59.195h9.834a.933.933 0 0 0 .591-.195.882.882 0 0 0 .318-.491zm.61 6.88c0-.977-.819-1.769-1.829-1.769s-1.828.792-1.828 1.77c0 .977.819 1.77 1.828 1.77 1.01 0 1.829-.793 1.829-1.77zm-9.141 0c0-.977-.819-1.769-1.828-1.769-1.01 0-1.828.792-1.828 1.77 0 .977.818 1.77 1.828 1.77 1.01 0 1.828-.793 1.828-1.77z",
    fill: "currentColor"
  })));
};
export default SvgCartV2;